export default __webpack_public_path__ + "static/media/Resource-Icons-Language-transparent.5514a8c9.png";